import styled, { css } from 'styled-components';
import { down } from 'styled-breakpoints';
import { motion } from 'framer-motion';

import { TransientProps } from '@common/types';
import { PerfectScrollbar } from '@components';

export const Container = styled(motion.dialog)`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 3rem 0;
    margin: auto;
    width: 100%;
    max-width: 50rem;
    max-height: 96%;
    border-radius: 1rem;
    position: relative;
    background: ${theme.colors.background[100]};
    color: ${theme.colors.foreground[100]};
    box-shadow: 0px 2.8px 2.2px rgba(0, 0, 0, 0.02),
      0px 6.7px 5.3px rgba(0, 0, 0, 0.028), 0px 12.5px 10px rgba(0, 0, 0, 0.035),
      0px 22.3px 17.9px rgba(0, 0, 0, 0.042),
      0px 41.8px 33.4px rgba(0, 0, 0, 0.05), 0px 100px 80px rgba(0, 0, 0, 0.07);
    > h2 {
      text-align: center;
      margin-bottom: 2rem;
      word-break: break-all;
    }
  `}
`;

export const Form = styled(PerfectScrollbar)`
  padding: 0 2rem;
  width: 84%;
  > label + div {
    margin-top: 1rem;
  }
  > button {
    margin-top: 1.5rem;
  }
  textarea {
    margin-top: 1rem;
  }
  ${down('md')} {
    padding: 0 1rem;
    width: 100%;
  }
`;

export const FormSettings = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 1.5rem 0;
`;

type FlexWrapperProps = TransientProps<{ maxWidth: number; break: boolean }>;

export const FlexWrapper = styled.div<Partial<FlexWrapperProps>>`
  ${({ $maxWidth: maxWidth = 50, $break: willBreak = false }) => css`
    display: flex;
    gap: 1rem;
    justify-content: space-between;
    margin-bottom: 1rem;
    width: 100%;
    label {
      max-width: calc(${maxWidth}% - 0.5rem);
      margin: 0;
    }
    ${down('sm')} {
      flex-direction: ${willBreak ? 'column' : 'row'};
      label {
        max-width: ${willBreak ? '100%' : 'calc(60% - 0.5rem)'};
      }
    }
    button {
      margin: 2rem auto 0 auto;
    }
  `}
`;
